import { useContext, useEffect, useMemo, useState } from 'react'

import { BabyPoopEmbed, useHealthToolsCache } from '@hhgtech/hhg-components'
import { BoxProps } from '@mantine/core'
import { formatBabyPoopPage } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { callApi, getApiPath, redirectToSSOWithReturnUrl } from 'api/utils'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { HEALTH_TOOL_TYPE, basePath } from 'interfaces/constants'
import { BabyPoopPage } from 'interfaces/types'
import router from 'next/router'
import { AppContext } from 'state/appContext'

export const BabyPoopCard = (props: BoxProps) => {
  const currentUrl = useCurrentUrl()
  const { locale } = useRouterExtend()
  const [babyPoopPage, setBabyPoopPage] = useState<BabyPoopPage>(
    {} as BabyPoopPage,
  )

  const { getHealthToolLink } = useHealthToolsCache(locale + '_MB')
  const babyPoopUrl = useMemo(
    () => getHealthToolLink(HEALTH_TOOL_TYPE.BABY_POOP),
    [getHealthToolLink],
  )
  const { state } = useContext(AppContext) || {}
  const { userInfo } = state || {}
  useEffect(() => {
    ;(async () => {
      const res = await callApi(
        getApiPath(PATHS.GET_HEALTH_TOOL_BABY_POOP),
        'GET',
      )
      setBabyPoopPage(formatBabyPoopPage(res?.data) as BabyPoopPage)
    })()
  }, [])
  const onClickFindOut = () => {
    const destination = `${
      typeof window !== 'undefined' ? window.location.origin : ''
    }${basePath}${babyPoopUrl}`
    if (!userInfo?.id) {
      redirectToSSOWithReturnUrl(destination, 'baby-poop-checking')
    } else {
      router.push(destination)
    }
  }

  if (!babyPoopUrl)
    return (
      <div
        style={{
          height: 300,
        }}
      />
    )

  const babyPoopPageProp = {
    ...babyPoopPage,
    reviewedBy: {
      display_name: babyPoopPage?.reviewedBy?.displayName || '',
      profile_url: babyPoopPage?.reviewedBy?.profileUrl || '',
      turn_off_profile: babyPoopPage?.reviewedBy?.turnOffProfile || false,
    },
  } as any

  return (
    <BabyPoopEmbed
      formProps={{
        babyPoopPage: babyPoopPageProp,
        currentUrl,
        onClickFindOut,
      }}
      babyPoopPage={babyPoopPageProp}
      {...props}
    />
  )
}
